export const GRS_PENDING_PAGE_SIZE = 5;

export const GRS_PENDING_ROW_BG = "cyan.50";
export const GRS_PENDING_ROW_HOVER_BG = "cyan.100";
export const GRS_VISIBLE_FOCUS_RING = {
  boxShadow: "0 0 0 2px var(--chakra-colors-blue-400)",
};

export const GRS_REJECTION_NOTES_MAX_LENGTH = 5000;
